// React
import React from 'react';
import config from 'config';
import { Link, withRouter } from 'react-router-dom';
import Utils from '../../utils/utils';
import InputMask from '../shared/inputMask.component.jsx';
import appRouter from '../../utils/appRouter';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';

import UserApi from '../../api/user-api';
import GameApi from '../../api/game-api';
import ModalApi from '../../api/modal-api';
import LoginApi from '../../api/login-api';
import jwt from 'jsonwebtoken';
import { v4 as uuid } from 'uuid';


class LoginForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			msisdn: null,
			validateCode: null,
			btnValidateCode: true
		};

		this.setStateValue = this.setStateValue.bind(this);
		this.activationStep = this.activationStep.bind(this);
		this.requestSMS = this.requestSMS.bind(this);
		this.reSendSMS = this.reSendSMS.bind(this);
		this.validateCode = this.validateCode.bind(this);
		this.subscribeMsisdn = this.subscribeMsisdn.bind(this);
	}

	componentDidMount() {
		let pendingSubscriptions = JSON.parse(localStorage.getItem('pendingSubscriptions') || '[]');
		pendingSubscriptions = pendingSubscriptions.filter(el => {
			try {
				return !!jwt.verify(el.token, config.application.subscribeRequestContext.secret);
			} catch (error) {
				return false;
			}
		});
		const params = new URLSearchParams(window.location.search);
		if (params && params.get('subscriptionId')) {
			const subscriptionId = params.get('subscriptionId');
			const entry = pendingSubscriptions.find(el => el.id === subscriptionId);
			if (entry) {
				const result = params.get('result');
				const { msisdn } = jwt.verify(entry.token, config.application.subscribeRequestContext.secret);
				if (result === 'success') {
					Utils.gaSend('Assinatura', 'Assinar usuário', 'Sucesso', msisdn);
					// console.log('Sending success data to GA', msisdn);
				} else {
					Utils.gaSend('Assinatura', 'Assinar usuário', 'Erro', msisdn);
					// console.log('Sending failure data to GA', msisdn);
				}
				pendingSubscriptions = pendingSubscriptions.filter(el => el.id !== subscriptionId);
			}
		}
		localStorage.setItem('pendingSubscriptions', JSON.stringify(pendingSubscriptions));
	}

	setStateValue(obj) {

		if (obj.validateCode) {
			const validateCode = obj.validateCode;

			if (validateCode.length === config.application.validateCodeSize) {
				this.setState({ btnValidateCode: false });
			} else {
				this.setState({ btnValidateCode: true });
			}
		}

		this.setState(obj);
	}

	activationStep(step) {
		LoginApi.activationStep(step);
	}

	requestSMS() {
		LoginApi.requestSMS(
            this.state.msisdn,
            config.constants.activationSteps.newUserValidation
        );
	}

	reSendSMS() {
		LoginApi.requestSMS(this.state.msisdn, config.constants.activationSteps.newUserValidation, true);
	}

	validateCode() {
		LoginApi.validateCode(this.state.msisdn, this.state.validateCode, config.constants.activationSteps.newUserValidation).then(isValid => {
			if (!isValid) return;

			UserApi.getUser(this.state.msisdn, false).then(user => {
				if (UserApi.hasPlanActive(user)) {
					LoginApi.activationStep(config.constants.activationSteps.alreadySubscribed);
				} else {
					this.subscribeMsisdn();
				}
			});
		});
	}

	subscribeMsisdn() {
		this.props.history.push('/error');
		// Redirect user to consent and save subscription request state to localStorage
		/* const subscribeRequestId = uuid();
		const token = jwt.sign({ msisdn: this.props.user.msisdn }, config.application.subscribeRequestContext.secret, {
			expiresIn: config.application.subscribeRequestContext.expiresIn
		});
		const pendingSubscriptions = JSON.parse(localStorage.getItem('pendingSubscriptions') || '[]');
		pendingSubscriptions.push({
			id: subscribeRequestId,
			token
		});
		localStorage.setItem('pendingSubscriptions', JSON.stringify(pendingSubscriptions));
		window.location.replace(
			`http://consent.clarosgvas.mobicare.com.br/security/lp/${config.constants.consentIds[config.application.activePromotion]}?redirect_uri=${encodeURI(window.location.toString())}&keep_params=result,subscriptionId&subscriptionId=${subscribeRequestId}`
		);
		return;
		/*UserApi.subscribeMsisdn(this.props.user.msisdn, config.constants.activationSteps.newUserValidation).then(user => {
			if (!user.msisdn) return;
			LoginApi.activationStep(config.constants.activationSteps.newSubscription);
		});*/
	}

	render() {
		let validateCodeLength = config.application.validateCodeSize;
		let msisdn = Utils.removeMsisdnPrefix(this.props.login.msisdn);
		let msisdnInHeader = this.props.login.msisdnInHeader;
		let activationStep = this.props.login.activationStep;
		let errorMsisdn = this.state.msisdnError;

		let btnAlreadyUser = null;
		if (!msisdnInHeader) {
			btnAlreadyUser = <button type="button" onClick={() => {
				this.activationStep(config.constants.activationSteps.alreadyUser);
			}} className="resendCode text-md">
				<FormattedMessage id="btn.alreadyUser" />
			</button>;
		}

		return (
			<div className="login-form">
				<div className="container-form">

					{/* UNKNOWN USER */}
					{(activationStep === config.constants.activationSteps.unknownUser) &&
						<div>
							<h2 className="text-lg">
								UNKNOWN USER
							</h2>

							<form onSubmit={e => {
								e.preventDefault();
							}}>
								<button type="button" onClick={() => {
									let nextStep = (msisdnInHeader) ?
										config.constants.activationSteps.newUserValidation :
										config.constants.activationSteps.newUser;
									this.activationStep(nextStep);
								}} className="btn btn-default">
									<FormattedMessage id="btn.activeNow" />
								</button>
								<br />
								{btnAlreadyUser}
							</form>
						</div>
					}

					{/* USER ALREADY SUBSCRIBED AND SIGNED */}
					{((activationStep === config.constants.activationSteps.alreadySubscribed) || (activationStep === config.constants.activationSteps.newSubscription)) &&
						<div>
							<p>
								{activationStep === config.constants.activationSteps.alreadySubscribed &&
									<FormattedHTMLMessage id="loginform.alreadySubscribed.title" />
								}
								{activationStep === config.constants.activationSteps.newSubscription &&
									<FormattedHTMLMessage id="loginform.newSubscription.title" />
								}
							</p>

							<br />

							<form onSubmit={e => {
								e.preventDefault();
							}}>
								<Link to={appRouter.getLink('game')} onClick={() => { Utils.gaSend('Assinatura', 'Estímulo', 'Jogue Agora'); }} className="btn btn-default">
									<FormattedHTMLMessage id="btn.startPlayNow" />
								</Link>
							</form>

						</div>
					}

					{/* MSISDN IN HEADER : NEW USER */}
					{(msisdnInHeader && activationStep === config.constants.activationSteps.newUser) &&
						<div>
							<p>
								<FormattedMessage id="loginform.HE.newUser.description" />
							</p>

							<form onSubmit={e => {
								e.preventDefault();
							}}>

								<div className="form-group">
									<InputMask mask="(99) 99999-9999" disabled="disabled" value={msisdn} className="inputMask"
										style={{
											'backgroundColor': 'transparent',
											'border': 'none',
											'height': 'auto',
											'width': '100%'
										}} />
								</div>

								<button type="button" onClick={() => {
									this.activationStep(config.constants.activationSteps.newUserValidation);
								}} className="btn btn-default">
									<FormattedMessage id="btn.activeNow" />
								</button>
							</form>
						</div>
					}

					{/* MSISDN IN HEADER : NEW USER VALIDATION */}
					{(msisdnInHeader && activationStep === config.constants.activationSteps.newUserValidation) &&
						<div>
							<form onSubmit={e => {
								e.preventDefault();
							}}>

								{this.props.error.subscribeNoCredits &&
									<p className="text-danger text-md">
										<FormattedHTMLMessage id="loginform.error.subscribeNoCredits" />
									</p>
								}
								{this.props.error.subscribeMsisdnError &&
									<p className="text-danger text-md">
										<FormattedHTMLMessage id="loginform.error.subscribeMsisdnError" />
									</p>
								}
								{this.props.error.subscribeGeneralError &&
									<p className="text-danger text-md">
										<FormattedHTMLMessage id="loginform.error.subscribeGeneralError" />
									</p>
								}

								<h2>
									<FormattedHTMLMessage id="loginform.HE.newUserValidation.description" />
								</h2>

								<button type="button" onClick={this.subscribeMsisdn} className="btn btn-default">
									<FormattedMessage id="btn.confirm" />
								</button>
							</form>
						</div>
					}

					{/* WIFI : NEW USER || ALREADY USER */}
					{(!msisdnInHeader && (activationStep === config.constants.activationSteps.newUser || activationStep === config.constants.activationSteps.alreadyUser)) &&
						<div>
							<p>
								<FormattedMessage id="loginform.newUser.description" /><br />
								<span class="text-md">
									<i><FormattedMessage id="loginform.newUser.price" /></i>
								</span>
							</p>

							<form onSubmit={e => {
								e.preventDefault();
							}}>

								<div className="form-group">
									<FormattedMessage id="msisdn.placeholder">
										{(msg) => (
											<InputMask maskType="phoneNumber" type="text" className="form-control" placeholder={msg}
												onChange={evt => {
													this.setStateValue({ msisdn: Utils.onlyNumbers(evt.target.value) });
												}} />
										)}
									</FormattedMessage>
								</div>

								{this.props.error.getUserError &&
									<p className="text-danger text-md">
										<FormattedHTMLMessage id={"loginform.error." + this.props.error.getUserError} />
									</p>
								}
								{this.props.error.requestSmsError &&
									<p className="text-danger text-md">
										<FormattedHTMLMessage id={"loginform.error." + this.props.error.requestSmsError} />
									</p>
								}


								<button type="button" onClick={this.requestSMS} className="btn btn-default">
									<FormattedMessage id="btn.wantPlay" />
								</button>
							</form>

						</div>
					}

					{/* WIFI : NEW USER VALIDATION || ALREADY USER VALIDATION */}
					{(!msisdnInHeader && (activationStep === config.constants.activationSteps.newUserValidation || activationStep === config.constants.activationSteps.alreadyUserValidation)) &&
						<div>
							<p>
								<FormattedMessage id="loginform.newUserValidation.description" />
							</p>

							<form onSubmit={e => {
								e.preventDefault();
							}}>

								<div className="text-bold form-group">
									<InputMask className="text-center" mask="99 99999-9999" disabled="disabled" className="inputMask" value={this.state.msisdn}
										style={{
											'backgroundColor': 'transparent',
											'border': 'none',
											'height': 'auto',
											'width': '100%'
										}} />
								</div>

								<p>
									<FormattedHTMLMessage id="loginform.newUserValidation.validationText" />
								</p>

								<div className="form-group">
									<input name="validateCode" placeholder="Ex: XXXX" type="text" className="form-control" maxLength={validateCodeLength}
										onChange={evt => {
											this.setStateValue({ validateCode: evt.target.value });
										}} />
								</div>

								<p className="text-danger text-md">
									{this.props.error.subscribeNoCredits &&
										<FormattedHTMLMessage id="loginform.error.subscribeNoCredits" />
									}
									{this.props.error.invalidValidationCode &&
										<FormattedHTMLMessage id="loginform.error.invalidCode" />
									}
									{this.props.error.subscribeMsisdnError &&
										<FormattedHTMLMessage id="loginform.error.subscribeMsisdnError" />
									}
									{this.props.error.subscribeGeneralError &&
										<FormattedHTMLMessage id="loginform.error.subscribeGeneralError" />
									}
									{this.props.login.resendCode &&
										<FormattedHTMLMessage id="loginform.error.resendCode" />
									}
								</p>

								<button type="button" onClick={this.validateCode} className="btn btn-default" disabled={this.state.btnValidateCode}>
									<FormattedMessage id="btn.confirm" />
								</button>
								<br />

								<button type="button" onClick={this.reSendSMS} className="text-md resendCode">
									<FormattedMessage id="btn.resendCode" />
								</button>
							</form>
						</div>
					}

					{/* FOOTERS */}
					{(activationStep === config.constants.activationSteps.newUser || activationStep === config.constants.activationSteps.alreadyUser) &&
						<p className="footer-text">
							<FormattedHTMLMessage id="loginform.footer.message1" />
						</p>
					}
					{(activationStep === config.constants.activationSteps.alreadySubscribed || activationStep === config.constants.activationSteps.newSubscription) &&
						<p className="footer-text">
							<FormattedMessage id="loginform.footer.message2.1" />
							<Link to={appRouter.getLink('help')}>
								<FormattedMessage id="loginform.footer.message2.2" />
							</Link>
							<FormattedMessage id="loginform.footer.message2.3" />
						</p>
					}
				</div>
			</div>
		);
	}
}

const mapStateToProps = function (store) {
	return {
		user: store.userState,
		login: store.loginState,
		error: store.errorState,
	};
};

export default withRouter(connect(mapStateToProps)(LoginForm));


// WEBPACK FOOTER //
// ./src/components/pages/loginForm.component.jsx